import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useHotelRoutePaths } from '@apps/guest/routes/HotelBooking/HotelBooking.routes';
import { pxToRem } from '@withjoy/joykit/theme';
import { useListingsPanelTelemetry } from '../ListingsPanel.telemetry';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const HotelCTA = ({ joyPlaceId, hotelName }: { joyPlaceId: string; hotelName?: string }) => {
  const { eventHandle } = useEventInfo();
  const { t } = useTranslation('accommodationsConsole');
  const hotelCTATrans = t('listingsPanel');
  const hotelRoute = useHotelRoutePaths();
  const redirectUrl = hotelRoute.hotelDetails.buildRelativeUrl(eventHandle || '', joyPlaceId, {
    utm_medium: 'web',
    utm_source: 'website_accommodations_console_page',
    utm_campaign: 'see_availability'
  });
  const telemetry = useListingsPanelTelemetry();
  const handleSeeAvailability = useEventCallback(() => {
    telemetry.seeAvailabilityClicked({ joyPlaceId, hotelName });
  });

  return (
    <Flex>
      <ButtonV2
        variant="solid"
        backgroundColor="newUITest1"
        width="100%"
        height={{ _: pxToRem(48), md: pxToRem(40) }}
        onClick={handleSeeAvailability}
        shape="rounded"
        as="a"
        href={redirectUrl}
        target="_blank"
      >
        {hotelCTATrans.hotelCTA.title()}
      </ButtonV2>
    </Flex>
  );
};
